<template>
    <div class="active">
        <el-card shadow="never" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
            <el-row>
                <el-col :span="9">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
                        <el-form-item label="券号" prop="voucherCode">
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value1" :maxlength="8"></el-input>
                            </el-col>
                            <el-col :span="1" :offset="1"> - </el-col>
                            <el-col :span="10">
                                <el-input v-model="ruleForm.voucherCode.value2" :maxlength="8"></el-input>
                            </el-col>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="submitForm('ruleForm')">添加</el-button>
                            <!-- <el-button type="info" @click="account">结算</el-button> -->
                            <el-button @click="cancel">返回</el-button>
                        </el-form-item>
                    </el-form>

                    <el-card>
                        <div slot="header" class="clearfix">
                            <span><i class="el-icon-goods" style="color:red;"></i>
                                购物车</span>
                            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                        </div>
                        <el-table :data="shopList" height="336" style="width: 100%">
                            <el-table-column prop="voucher" label="券号" width="180">
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button-group>
                                        <el-tooltip class="item" effect="dark" content="刪除" placement="bottom">
                                            <el-button size="mini" @click.native.prevent="
                                                remove(
                                                    scope.$index,
                                                    shopList
                                                )
                                                ">
                                                刪除
                                            </el-button>
                                        </el-tooltip>
                                    </el-button-group>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="text">{{
                                        everyMaxval(scope.$index, scope.row)
                                    }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-form label-width="72px" label-position="left">
                            <!-- <el-form-item label="支付方式" prop="confirmQty" style="margin-bottom:0">
                                <el-col :span="18" :md="12">
                                    <el-select v-model="value" placeholder="请选择结算方式" @change="handleChange">
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :md="12">
                                    <el-button type="info" @click="account" size="medium ">结算</el-button>
                                </el-col>
                            </el-form-item> -->
                            <!-- <el-form-item v-if="isDiscounts">
                                <el-row :span="24">
                                    <el-col :span="4" :md="12">
                                        <el-button type="info" @click="balance" size="medium ">显示总金额</el-button>
                                    </el-col>
                                </el-row>
                            </el-form-item> -->
                            <el-row :gutter="20">
                                <el-col :span="13">
                                    <el-form-item label="总金额 " prop="showTotalPrice" class="total-price">
                                        <el-input v-model="showTotalPrice" :readonly="true"></el-input>

                                        <!-- <el-col :span="4">
                                        <el-button
                                            type="info"
                                            @click="balance"
                                            size="medium "
                                            >显示总金额</el-button
                                        >
                                    </el-col> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="总数量 " prop="showTotalPrice" class="total-price">
                                        <el-input v-model="showTotalMount" :readonly="true"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="13">
                                    <el-form-item label="优惠金额" prop="disCountVal" v-if="isDiscounts">
                                        <el-input v-model="disCountVal" :readonly="true"></el-input>

                                        <!-- <el-col :span="4">
                                        <el-button
                                            type="info"
                                            @click="balance"
                                            size="medium "
                                            >显示总金额</el-button
                                        >
                                    </el-col> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="大客户价" prop="bigDisCountVal" v-if="isBigcounts">
                                        <el-input v-model="bigDisCountVal" type="number" @input="discountInp"></el-input>
                                    </el-form-item>
                                    <el-button v-if="isApyBigcounts" @click="appCusDis">申请大客户价</el-button>
                                </el-col>

                            </el-row>

                            <!-- <el-form-item
                                label="优惠金额"
                                prop="disCountVal"
                                v-if="isDiscounts"
                            >
                                <el-row :span="24">
                                    <el-col :span="10">
                                        <el-input
                                            v-model="disCountVal"
                                            disabled="true"
                                            @input="discountInp"
                                        ></el-input>
                                    </el-col>
                                    
                                </el-row>
                              
                            </el-form-item> -->

                            <el-form-item label="支付金额" prop="paymentAmount" v-if="isPayment">
                                <el-row :span="24">
                                    <el-col :span="10">
                                        <el-input v-model="paymentAmount" :readonly="true"></el-input>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item class="confirmCon">
                                <el-row :span="24">
                                    <el-col :span="10" :offset="7">
                                        <el-button type="primary" @click="account" class="confirmBtn">结算</el-button>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </el-col>
                <el-col :span="14" :offset="1">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span><i class="el-icon-error" style="color:red;"></i>
                                错误信息</span>
                            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                        </div>
                        <el-table :data="errData" height="520" style="width: 100%">
                            <el-table-column prop="code" label="券号" width="100">
                            </el-table-column>
                            <el-table-column prop="status" label="状态" width="80">
                            </el-table-column>
                            <el-table-column prop="location" label="地点名称">
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
            </el-row>
        </el-card>
        <el-dialog title="请使用收款POS机扫描二维码" :visible.sync="centerDialogVisible" @close="close" width="30%" center>
            <div style="text-align:center">
                <img :src="src" width="200px" height="200px" />
                <p style="text-align:center"></p>
                <p style="text-align:center">
                    订单号: {{ orderDetail.orderNo }}
                </p>
                <p style="text-align:center">
                    金额: {{ orderDetail.totalPrice }}
                </p>
                <p style="text-align:center">请在此页面停留等待支付结果</p>
                <p style="text-align:center" class="ordertime">
                    <i class="el-icon-time"></i><span>{{ orderTime }}</span>
                </p>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogCancel()">取 消</el-button>
                <el-button type="primary" @click="dialogNoCancel()">确 定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>
<style lang="less">
.line {
    text-align: center;
}

.confirmCon,
.total-price {
    margin-top: 20px;
}

.confirmBtn {
    margin-left: 0;
    width: 100%;
}

.ordertime {
    padding: 10px 0;
    font-size: 28px;
}

.ordertime span {
    margin: 10px;
}

.el-icon-time {
    font-size: 28px;
}
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
let timer;
let timer1;
export default {
    mixins: [requestMixin, common],
    inject: ['reload'],
    data() {
        var validatorQty = (rule, value, callback) => {
            let value1 = Number.isInteger(value.value1);
            let value2 = Number.isInteger(value.value2);
            if (value.value1 == '') {
                callback(new Error("第一个券号不能为空！"));
            } else {
                if (value.value1 != '' && value.value2 == '') {
                    let val = this.trim(value.value1);
                    //  console.log(value.value1.length)
                    if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(val) == false) {
                        callback(new Error("请填写大于0的数字"));
                        // console.log('请填写大于0的数字')
                    } else if (/[+]/g.test(value.value1)) {
                        callback(new Error("请输入大于0的数字"));
                    } else if (value.value1.length != 8) {
                        callback(new Error("请输入8位数的券号！"));
                    } else {
                        callback();
                    }
                } else if (value.value2 != '' && value.value1 != '') {
                    if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value2) == false || (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value.value1) == false) {
                        callback(new Error("请填写大于0的数字"));
                    } else if (value.value2 - value.value1 < 0) {
                        callback(new Error("第二位数要大于第一位数"));
                    } else if (value.value2 < 0 || value.value1 < 0) {
                        callback(new Error("必须填写大于0的数字"));
                    } else if (/[+]/g.test(value.value2) || /[+]/g.test(value.value1)) {
                        callback(new Error("请输入大于0的数字"));
                    } else if (value.value2.length != 8 || value.value1.length != 8) {
                        callback(new Error("请输入8位数的券号！"));
                    } else {
                        callback();
                    }
                }
            }
        }
        return {
            ruleForm: {
                voucherCode: {
                    value1: "",
                    value2: ""
                },
                confirmQty: ''
            },
            shopList: [],
            rules: {
                voucherCode: [
                    { validator: validatorQty, required: true, trigger: 'blur', type: 'number' },
                    // { message: '请填写券号', trigger: 'blur' }
                ]
            },
            errData: [],
            options: [],
            value: "",
            desLabel: '',
            loading: false,
            centerDialogVisible: false,
            src: '',
            orderDetail: {},
            orderTime: '',
            isDiscounts: false,
            isBigcounts: false,
            isApyBigcounts: false,
            isPayment: false,
            disCountVal: '',
            bigDisCountVal: '',
            showTotalPrice: '',
            showTotalMount: '',
            paymentAmount: '',
            hasDisRetailPrice: ''
            // everyMaxval:''
        }
    },
    created() {
        // console.log()
    },
    mounted() {
        let { confirmQty } = this.$route.query;
        this.ruleForm.confirmQty = confirmQty;
        this.getComply().then(res => {

            let { discount, complimentary } = res;
            debugger
            if (complimentary == 'Y' || discount == "N") {

            } else if (discount == "Y" || complimentary == "N") {
                //优惠金额
                debugger
                this.isDiscounts = true;
                this.isPayment = true;
                let userLevel = sessionStorage.getItem("treeId")
                let bigCus = sessionStorage.getItem("bigCus")
                console.log("大客户价" + userLevel.indexOf("26"))
                if (userLevel.indexOf("26") > 0 || bigCus == 'Y') {
                    this.isBigcounts = true;
                } else {
                    this.isApyBigcounts = true;
                }

            }
        });
    },
    methods: {
        //确认券号信息
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    let { voucherCode } = this.ruleForm;
                    let userId = sessionStorage.getItem("userId");
                    this.getUserLocation().then(res => {
                        let code = res;
                        let params = {
                            from: voucherCode.value1,
                            to: voucherCode.value2 == "" ? voucherCode.value1 : voucherCode.value2
                        }
                        let maxVal = params.to - params.from;
                        this.errData = [];
                        if (maxVal <= 300 && maxVal >= 0) {
                            //验证是否可以添加至购物车
                            let checkParams = {
                                act: 'checkrange',
                                from: voucherCode.value1,
                                to: voucherCode.value2 == "" ? voucherCode.value1 : voucherCode.value2,
                                checkLocation: code,
                                checkStatus: "A",
                                userId
                            }

                            this.checkedRange(checkParams, '添加')
                        } else {
                            this.alert('批量销售最多为300张！', 'warning')
                        }
                    })
                    //样式调整

                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },

        //点击取消，跳转到上一页
        cancel() {
            this.$router.go(-1)
        },
        remove(index, rows) {
            rows.splice(index, 1);
            this.balance();
        },
        /**
         * 验证券
        */
        checkedRange(checkParams, text) {
            let that = this;
            let { from, to } = checkParams;
            that.loading = true;
            that.delType(checkParams).then((res) => {
                //console.log(res)
                let { status, errorData } = res.data;
                let len = errorData.length;
                if (status == true && len == 0) {
                    //执行添加
                    that.loading = false;

                    // let maxVal = to - from;
                    // let everyMaxval = maxVal+1;
                    // that.everyMaxval = everyMaxval;
                    // console.log(everyMaxval)


                    this.addShopList(checkParams);
                    // that.handleAtive(params,text); //处理批量核销
                } else if (status == true && len > 0) {
                    //显示错误
                    that.loading = false;
                    this.alert(`不能${text},请确保券的状态是否正确!`, 'warning');
                    //console.log(errorData)
                    for (let i = 0; i < errorData.length; i++) {
                        errorData[i].status = that.formalStatus(errorData[i].status);
                        errorData[i].complimentary = 'null' ? '否' : '是';
                    }
                    that.errData = errorData;

                }
            })
        },

        everyMaxval(index, row) {
            let max = (row.voucher).split('-');
            let value = (max[1] - max[0]) + 1;
            return value;
        },
        /**
         * 添加至购物车
         */
        addShopList(checkParams) {
            let that = this;
            //添加至购物车
            let len = that.shopList.length;
            let vouchers = {
                voucher: `${checkParams.from}-${checkParams.to} `
            }
            that.errData = [];
            let newObj = []
            for (var i = 0; i < len; i++) {
                if (vouchers.voucher == that.shopList[i].voucher) {
                    newObj.push(i);
                }
            }
            if (newObj.length == 0) {
                that.shopList.push(vouchers);
                //显示金额
                // console.log(that.shopList)
                that.balance();
                that.ruleForm.voucherCode = {
                    value1: '',
                    value2: ''
                };
            } else {
                this.alert('请勿重复添加', "warning")
            }

        },

        discountInp(e) {
            const BigNumber = require('bignumber.js');
            let that = this;
            let showTotalPrice = that.showTotalPrice;
            let disCountVal = that.disCountVal;
            let compareDiscount = (showTotalPrice - e).toFixed(1);
            let num1 = new BigNumber(compareDiscount);
            let num2 = new BigNumber(disCountVal);
            if (e) {

                that.paymentAmount = num1.minus(num2).toFixed(1)//compareDiscount - disCountVal;
            } else {
                if (disCountVal) {
                    that.paymentAmount = num1.minus(num2).toFixed(1) //compareDiscount - disCountVal;
                } else {
                    that.paymentAmount = compareDiscount;
                }

            }
            if (that.paymentAmount <= 0) {
                that.paymentAmount = 0.01;
            }
        },
        /**
         * 下拉选框
        */
        handleChange(value) {
            this.value = value;
            let desObj = this.options.find((elem) => {
                return elem.value == value;
            });
            let getName = '';
            getName = desObj.label;
            this.desLabel = getName;

        },
        // 显示总金额
        balance() {
            let that = this;
            that.loading = true;
            let shopList = this.shopList;
            let shopListObj = shopList.map(elem => {
                return this.trim(elem.voucher)
            })
            let ranges = shopListObj.join(',');
            let userId = sessionStorage.getItem("userId");
            let disCountVal = that.disCountVal;
            let isDiscounts = that.isDiscounts;
            let compareDiscount = Number(disCountVal);
            let params = {
                act: 'checkTotalPrice',
                ranges,
                userId
            }
            // console.log(params)
            if (ranges) {
                that.delType(params).then(res => {
                    // console.log(res)
                    let { code, data, status, msg } = res.data;
                    if (status == true) {
                        that.loading = false;
                        let { totalPrice, totalCount, disPrice, payPrice, hasDisRetailPrice } = data;
                        that.showTotalPrice = totalPrice;
                        that.showTotalMount = totalCount;
                        that.hasDisRetailPrice = hasDisRetailPrice;
                        debugger
                        if (!disPrice) {
                            that.disCountVal = 0;
                            // that.isDiscounts =false;
                        } else {
                            that.disCountVal = disPrice;
                        }
                        that.paymentAmount = payPrice;

                    } else {
                        that.loading = false;
                        this.alert(`${msg}`, 'warning');
                    }
                })
            } else {
                that.loading = false;
                that.showTotalPrice = '';
                that.showTotalMount = '';
                that.disCountVal = '';
                that.paymentAmount = '';
                this.$alert('购物车为空，请先加入购物车', '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    center: true
                })
            }

        },
        account() {
            //结算
            debugger
            let shopList = this.shopList;
            let shopListObj = shopList.map(elem => {
                return this.trim(elem.voucher)
            })
            let ranges = shopListObj.join(',');
            let ptype = this.value;
            let userId = sessionStorage.getItem('userId');
            let showTotalPrice = this.showTotalPrice; //总金额
            let disCountVal = this.disCountVal;       //优惠金额
            let paymentAmount = this.paymentAmount;  //支付金额
            let isDiscounts = this.isDiscounts;  //是否显示
            if (isDiscounts || this.isPayment) {
                if (paymentAmount < 0 && ranges) {
                    this.alert('支付金额不能为负数!', 'warning')
                } else if (paymentAmount > 0 && ranges) {
                    this.loading = true;
                    this.getPaymentImg();
                } else if (!paymentAmount) {
                    this.alert('请先输入优惠金额!', 'warning')
                } else if (paymentAmount && !ranges) {
                    this.alert('购物车为空，请先加入购物车!', 'warning')
                } else if (paymentAmount == 0 && !showTotalPrice) {
                    this.alert('券号异常', 'warning')
                } else if (paymentAmount == 0 && showTotalPrice) {
                    this.loading = true;
                    this.getPaymentImg();
                }
            } else {
                if (!ranges) {
                    this.alert('购物车为空，请先加入购物车!', 'warning');
                } else {
                    this.loading = true;
                    this.getPaymentImg();
                }
            }

            // if (ranges ) {
            //     this.loading = true;
            //     this.getPaymentImg()
            // } else {
            //     this.$alert('购物车为空，请先加入购物车', '提示', {
            //         confirmButtonText: '确定',
            //         type: 'error',
            //         center: true
            //     })
            // }
        },
        handleAtive(params, text) {
            let value = this.value;
            let desLabel = this.desLabel;
            this.getComply().then((res) => {
                let { discount, complimentary } = res;
                // console.log(res)
                if (complimentary == "N" && discount == "N") {
                    this.$confirm(`是否${text}券号 ${params.ranges}?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        let loading = this.loadingCommon();
                        this.delType(params).then((res) => {
                            // console.log(res)
                            if (res.data.status == true && res.data.data.qty !== '0') {
                                loading.close();
                                this.$confirm(`${text}成功 ${res.data.data.qty} 销售单号为:${res.data.data.salesOrder}`, '提示', {
                                    confirmButtonText: '确定',
                                    showCancelButton: false,
                                    type: 'success'
                                }).then(() => {
                                    this.promptMsg(`${text}成功`, 'success');
                                    this.ruleForm = {
                                        voucherCode: {
                                            value1: "",
                                            value2: ""
                                        },
                                        locationCode: '',
                                        complimentary: ''
                                    }
                                    this.value9 = '';
                                    this.reload();
                                }).catch(() => {
                                    this.promptMsg('已取消', 'info');
                                })
                            } else if (res.data.status == true && res.data.data.qty == '0') {
                                loading.close();
                                this.$confirm(`${text}成功 ${res.data.data.qty}`, '提示', {
                                    confirmButtonText: '确定',
                                    showCancelButton: false,
                                    type: 'success'
                                }).then(() => {
                                    this.alert(`请查看券号是否输入正确或此券已经${text}过 !`, 'warning')
                                    // this.$router.push({ path : '/ticket/manageList'});
                                }).catch((error) => {
                                    this.promptMsg('已取消', 'info');
                                });
                            } else {
                                loading.close();
                                this.$alert(`${text}失败`, '提示');
                            }
                        })
                    }).catch(() => {
                        // loading.close();
                        this.promptMsg('已取消', 'info')
                    })
                } else if (discount == "Y") {
                    // console.log(discount)
                    this.isDiscounts = true;
                    this.$confirm(`是否${text}券号 ${params.ranges}?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        let loading = this.loadingCommon();
                        //获取地点
                        this.delType(params).then((res) => {
                            if (res.data.status == true && res.data.data.qty !== '0') {
                                loading.close();
                                this.$confirm(`${text}成功 ${res.data.data.qty} 销售单号为:${res.data.data.salesOrder}`, '提示', {
                                    confirmButtonText: '确定',
                                    showCancelButton: false,
                                    type: 'success'
                                }).then(() => {
                                    this.promptMsg(`${text}成功`, 'success');
                                    this.ruleForm = {
                                        voucherCode: {
                                            value1: "",
                                            value2: ""
                                        },
                                        locationCode: '',
                                        complimentary: ''
                                    }
                                    this.value9 = '';
                                    this.reload();
                                }).catch(() => {
                                    this.promptMsg('已取消', 'info');
                                })
                            } else if (res.data.status == true && res.data.data.qty == '0') {
                                loading.close();
                                this.$confirm(`${text}成功 ${res.data.data.qty}`, '提示', {
                                    confirmButtonText: '确定',
                                    showCancelButton: false,
                                    type: 'success'
                                }).then(() => {
                                    this.alert(`请查看券号是否输入正确或此券已经${text}过 !`, 'warning')
                                    // this.$router.push({ path : '/ticket/manageList'});
                                }).catch((error) => {
                                    this.promptMsg('已取消', 'info');
                                });
                            } else {
                                loading.close();
                                this.alert(`${text}失败`, 'warning');
                            }
                        })
                    }).catch(() => {
                        // loading.close();
                        this.promptMsg('已取消', 'info')
                    })
                }
            })
        },
        //申请大客户价
        appCusDis() {
            let that = this;
            this.findAllUser("SYSADMIN").then(res => {
                debugger
                if (res.length > 0) {
                    let phone = res[0].phone;
                    let params = {
                        act: 'addCustomerApple',
                        userId: sessionStorage.getItem("userId"),
                        phone: sessionStorage.getItem("phone")
                    }
                    that.delType(params).then(res => {
                        let {
                            data,
                            status,
                            msg
                        } = res.data;
                        if (status) {
                            that.alert('申请成功等待处理', 'info');
                        } else {
                            that.alert(msg, 'warning');
                        }
                    })
                }
            })

        },
        //能否生成订单
        getImg() {
            let that = this;
            let shopList = this.shopList;
            let shopListObj = shopList.map(elem => {
                return this.trim(elem.voucher)
            })
            debugger
            let ranges = shopListObj.join(',');
            let userId = sessionStorage.getItem("userId");
            let disCountVal = that.disCountVal;
            let bigDisCountVal = that.bigDisCountVal;
            let isDiscounts = that.isDiscounts;
            let compareDiscount = Number(disCountVal);
            let hasDisRetailPrice = that.hasDisRetailPrice
            let params;
            // console.log(disCountVal)
            // console.log(compareDiscount)
            if (isDiscounts || that.isPayment) {
                params = {
                    act: 'generateOrder',
                    ranges,
                    userId,
                    discount: disCountVal,
                    bigDisCountVal: bigDisCountVal,
                    hasDisRetailPrice: hasDisRetailPrice
                }
            } else {
                params = {
                    act: 'generateOrder',
                    ranges,
                    userId
                }
            }
            let p = new Promise((resolve, reject) => {
                that.delType(params).then(res => {
                    let {
                        data,
                        status
                    } = res.data;
                    if (status) {
                        resolve(data)
                    } else if (Array.isArray(data)) {
                        that.loading = false;
                        that.$confirm('此订单已生成过订单，请去订单中心查看！', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            // that.reload();
                            that.$router.push({
                                path: '/setting/message'
                            })
                        }).catch((error) => {
                            that.reload();
                        })
                    } else if (status == false) {
                        that.loading = false;
                        that.alert('不能生成销售二维码!', 'warning');
                    }
                }).catch(() => {
                    that.loading = false;
                    that.alert(apis.warningTip, 'warning');
                })
            })
            return p;
        },
        getPaymentImg() {
            let that = this;
            that.getImg().then((res) => {
                let userId = sessionStorage.getItem("userId");
                let { orderNo, totalPrice, orderType } = res;
                let disCountVal = that.disCountVal;
                let compareDiscount = totalPrice - Number(disCountVal);
                if (totalPrice < 0) {
                    totalPrice = 0.01;
                }
                if (orderNo && orderType == 0) {
                    that.loading = false;
                    let src = `${apis.baseURL}?act=paymentImg&orderNo=${orderNo}&totalPrice=${totalPrice}&userId=${userId}`;
                    that.src = src;
                    that.orderDetail = {
                        orderNo,
                        totalPrice
                    }
                    that.centerDialogVisible = true;
                    that.getCheckOrderTime(orderNo, userId).then((res) => {
                        let { code, status, data } = res.data;
                        let orderTime = 0;
                        if (code == 200 && status == true) {
                            timer1 = setInterval(function () {
                                orderTime++;
                                that.orderTime = that.formatSeconds(orderTime);
                                if (orderTime == data) {
                                    clearInterval(timer1);//到时间取消执行
                                    // clearInterval(timer);//到时间取消执行
                                    that.centerDialogVisible = false;
                                    that.$confirm(`订单超时，支付取消`, '提示', {
                                        confirmButtonText: '查看订单',
                                        cancelButtonText: '退出',
                                        type: 'warning'
                                    }).then(() => {
                                        clearInterval(timer);//到时间取消执行
                                        that.$router.push({  //跳转详情
                                            path: '/setting/orderDetails',
                                            query: {
                                                orderNo,
                                                userId,
                                                orderType
                                            }
                                        })
                                    }).catch(() => {
                                        clearInterval(timer);//到时间取消执行
                                        that.reload()
                                    });


                                }
                            }, 1000);//每1000毫秒执行一次
                        }
                    })
                    timer = setInterval(() => {
                        // console.log('1')
                        that.payStatus(orderNo, userId, orderType);
                    }, 1000)

                    // console.log(src)
                    // that.loading = false;
                    // that.$alert("<p style='text-align:center'><img src=" + src + " width=200px height=200px><p style='text-align:center'></p><p style='text-align:center'>订单号:"+orderNo+"</p><p style='text-align:center'>订单号:"+totalPrice+"</p><p style='text-align:center'>请在此页面停留等待支付结果</p><p style='text-align:center'><i class='el-icon-time'></i></p></p>", '请使用收款POS机扫描二维码', {
                    //     dangerouslyUseHTMLString: true,
                    //     center: true,
                    //     showConfirmButton:false,
                    //     callback: action => {
                    //         this.$message({
                    //             type: 'info',
                    //             message: `关闭`
                    //         });
                    //         this.reload();
                    //         clearInterval(timer);
                    //     }
                    // }).then(action => {
                    //     clearInterval(timer)
                    // });

                    // timer = setInterval(() => {
                    //     console.log('1')
                    //     that.payStatus(orderNo, userId);
                    // }, 1000)
                } else if (orderNo && orderType == 1 || orderType == 2) {
                    let params = {
                        act: 'freeOrder',
                        orderNo,
                        userId
                    }
                    that.delType(params).then((res) => {
                        // console.log(res)
                        let { code, status } = res.data;
                        if (code == 200 && status) {
                            that.loading = false;
                            that.$router.push({
                                path: '/setting/orderDetails',
                                query: {
                                    orderNo,
                                    userId,
                                    orderType
                                }
                            })
                        } else {
                            that.loading = false;
                            that.alert('销售失败，请重新销售！', warning)
                        }
                    })
                }
            }).catch(error => {
                this.loading = false;
            })
        },
        //关闭
        close() {
            // console.log('关闭')
            let { orderNo, userId } = this.$route.query;
            this.centerDialogVisible = false;
            clearInterval(timer);
            clearInterval(timer1);
            this.reload();
        },
        getCheckOrderTime(orderNo, userId) {
            let that = this;
            let params = {
                act: 'checkOrderTime',
                orderNo,
                userId
            }
            let orderTimePromise = new Promise((resolve, reject) => {
                that.delType(params).then((res) => {
                    // console.log(res)
                    resolve(res)
                }).catch((error) => {
                    // console.log(error)
                    this.alert(apis.warningTip, 'warning');
                })
            })
            return orderTimePromise;

        },
        payStatus(orderNo, userId, orderType) {
            let that = this;
            let params = {
                act: 'payStatus',
                orderNo,
                userId
            }
            that.delType(params).then((res) => {
                let { payStatus } = res.data.data;
                if (payStatus && payStatus.paySuccess) {
                    clearInterval(timer);
                    clearInterval(timer1);
                    that.$message({
                        type: 'success',
                        message: `支付成功`
                    })
                    that.centerDialogVisible = false;
                    that.$router.push({
                        path: '/setting/orderDetails',
                        query: {
                            orderNo,
                            userId,
                            orderType
                        }
                    })
                } else if (payStatus && payStatus.paySuccess == false && payStatus.orderOut) {
                    clearInterval(timer);
                    clearInterval(timer1);
                    that.centerDialogVisible = false;
                    that.$message({
                        type: 'warning',
                        message: '订单取消'
                    })
                    // that.getDetailsList(orderNo, userId)
                }
            })
        },
    }
}
</script>
